import {
  Icons,
} from '@codev/helix-react';
import {
  HelpBlock
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import colorDeterminer from './colorDeterminer.js';
import ToolTip from './ToolTip.jsx';

class SchemePanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };
  }

  render() {
    let {
      description,
      methodName,
      onSelect,
      onTooltipShow,
      selected,
      toolTipContent,
      toolTipLinkText,
      validationState,
      helpText
    } = this.props;
    let {
      hovered,
    } = this.state;

    let colors = colorDeterminer({
      error: validationState === 'error',
      hovered,
      selected,
    });

    return (
      <div
        onClick={onSelect}
        onMouseEnter={() => this.setState({hovered: true})}
        onMouseLeave={() => this.setState({hovered: false})}
        style={{
          backgroundColor: '#FFFFFF',
          border: `2px solid ${colors.borderColor}`,
          cursor: 'pointer',
          margin: '10px',
          padding: '20px',
          position: 'relative',
          width: '250px',
        }}
      >
        {
          selected &&
            <Icons.Checkmark
              style={{
                fill: colors.borderColor,
                float: 'right',
                fontSize: '16px',
                position: 'absolute',
                right: '20px',
                top: '20px',
              }}
            />
        }
        <div
          style={{
            color: colors.methodTextColor,
            fontWeight: 'bolder',
            marginTop: '10px',
            textAlign: 'center',
          }}
        >
          {methodName}
        </div>
        <div
          style={{
            color: colors.descriptionTextColor,
            fontSize: '14px',
            marginTop: '10px',
            textAlign: 'center',
          }}
        >
          {description}
          {
            toolTipLinkText &&
            <>
              &nbsp;<ToolTip
                content={toolTipContent}
                onShow={onTooltipShow}
                targetText={toolTipLinkText} />
            </>
          }
          {
            helpText &&
            <HelpBlock>
              {helpText}
            </HelpBlock>
          }
        </div>
      </div>
    );
  }
}

SchemePanel.defaultProps = {
  onTooltipShow: () => {},
};

SchemePanel.propTypes = {
  description: PropTypes.node.isRequired,
  methodName: PropTypes.node.isRequired,
  onSelect: PropTypes.func.isRequired,
  onTooltipShow: PropTypes.func,
  selected: PropTypes.bool.isRequired,
  toolTipContent: ToolTip.propTypes.content,
  toolTipLinkText: PropTypes.node,
  helpText: PropTypes.node
};

export default SchemePanel;